import { NavigationClient, NavigationOptions } from '@azure/msal-browser';
import { NavigateFunction } from 'react-router-dom';

export class CustomNavigationClient extends NavigationClient {
    constructor(private navigate: NavigateFunction) {
        super();
    }

    async navigateInternal(url: string, options: NavigationOptions) {
        console.log(url);
        const relativePath = url.replace(window.location.origin, '');
        if (options.noHistory) {
            this.navigate(relativePath, { replace: true });
        } else {
            this.navigate(relativePath);
        }

        return false;
    }
}
